export enum PhysicalInventoryStatus {
    processing = -1,
    inProgress = 0,
    complete = 1,
    error = 99
}

export enum PhysicalInventoryPricingStatus {
    notStarted = 0,
    refreshing = 1,
    processed = 2,
    error = 99
}